import './PreviewButton.scss';

import { useContext, useEffect, useState } from 'react';

import { Button } from '../../../atom/Button/Button';
import { Modal } from '../../../atom/Modal/Modal';
import { CustomEditorContext } from '..';

/**
 * 에디터 툴바의 미리보기 버튼
 */
export const PreviewButton = () => {
  const { editor } = useContext(CustomEditorContext);

  const [isModalOpened, setIsModalOpened] = useState(false);
  const [content, setContent] = useState('');

  useEffect(() => {
    if (isModalOpened && editor) {
      const contentHtml = editor.getHTML();
      setContent(contentHtml);
    }
  }, [isModalOpened, editor]);

  return (
    <>
      <Button
        dimensions="H26"
        roundness="rectangle"
        onClick={() => {
          setIsModalOpened(true);
        }}
      >
        미리보기
      </Button>
      <Modal
        className="preview-button-modal max-h-[90vh] w-full max-w-[800px]"
        opened={isModalOpened}
        onClose={() => setIsModalOpened(false)}
      >
        <div className="max-h-full overflow-auto">
          <article
            className="text-start text-Gray-black"
            dangerouslySetInnerHTML={{
              __html: content,
            }}
          />
        </div>
      </Modal>
    </>
  );
};
